import React from 'react';
import { useTranslate } from 'react-admin';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Controller } from 'react-hook-form';

function OptionalTags(props) {
    const { control, optionalTags, errors } = props;

    const translate = useTranslate();

    return (
        <Controller
            control={control}
            name={'optional_tags'}
            render={({ field: { onChange, value } }) => (
            <Autocomplete
                fullWidth={true}
                multiple
                options={optionalTags}
                groupBy={(tag) => tag.group}
                getOptionLabel={(option) => option.name}
                getOptionSelected={ (option, value) => option.id == value.id }
                onChange={(event, value) => { onChange(value) }}
                value={value ?? []}
                renderInput={(params) => 
                    <TextField 
                        {...params}
                        label={translate(`cmss.resources.file-explorer.tags.optional-tags`)}
                        variant="outlined"
                        error={errors.optional_tags ? true : false}
                        helperText={errors?.optional_tags?.message ?? undefined}
                    />
                }
            />)}
        />
    );
}

export default OptionalTags;